// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + ".js";
};